import script from "./event.vue?vue&type=script&setup=true&lang=js"
export * from "./event.vue?vue&type=script&setup=true&lang=js"

import "./event.vue?vue&type=style&index=0&id=31065b48&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31065b48"]])

export default __exports__